import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const rule = css`
  display: flex;
  align-items: center;
  color: ${colors.gray.dark};
  text-decoration: none;
  margin-top: 10px;
  &:before {
    display: block;
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: ${colors.primary.default};
  }
  &.darkTheme {
    color: ${colors.white};
  }
  &.fulfilled {
    color: ${colors.gray.default};
    text-decoration: line-through;
    &:before {
      background-color: ${colors.gray.light};
    }
  }
`;

export const rulesContainer = css`
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
  & > span {
    flex: 0 50%;
  }
`;

export const safePasswordContainer = css`
  display: flex;
  height: 28px;
  align-items: center;
  background-color: rgba(3, 216, 169, 0.1);
  margin-top: 10px;
  border-radius: 5px;
`;

export const checkIcon = css`
  width: 12px;
  height: 12px;
  margin: 8px 10px;
  color: ${colors.success.default};
`;

export const safePasswordCaption = css`
  && {
    font-weight: ${fonts.weight.bold};
    color: ${colors.success.default};
  }
`;

export const passwordCaption = (isDarkTheme?: boolean) => css`
  && {
    color: ${isDarkTheme ? colors.white : colors.black};
  }
`;

export const passwordCount = css`
  font-weight: ${fonts.weight.bold};
`;

export const confirmPasswordPanel = css`
  && {
    margin-top: 40px;
  }
`;

export const formLabel = (isDarkTheme?: boolean) => css`
  &&& {
    color: ${isDarkTheme ? colors.white : colors.gray.dark};
  }
`;

export const container = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`;

export const actions = css`
  display: flex;
  margin-top: 40px;
`;

export const confirmButton = (showCancelButton?: boolean) => css`
  && {
    margin-right: ${showCancelButton ? '10px' : '0'};
    width: ${showCancelButton ? '160px' : '100%'};
  }
`;

export const cancelButton = css`
  && {
    width: 160px;
  }
`;
